<template>
    <div class="agreement-wrap">
        <Student v-if="type === 0"></Student>
        <Teacher v-if="type === 1"></Teacher>
        <Group v-if="type === 2"></Group>
        <StudentSecret v-if="type === 3"></StudentSecret>
        <TeacherSecret v-if="type === 4"></TeacherSecret>
        <GroupSecret v-if="type === 5"></GroupSecret>
    </div>
</template>

<script>
import Student from '../components/Agreement/Student';
import Teacher from '../components/Agreement/Teacher';
import Group from '../components/Agreement/Group';
import StudentSecret from '../components/Secret/Student';
import TeacherSecret from '../components/Secret/Teacher';
import GroupSecret from '../components/Secret/Group';

export default {
    components: {
        Student,
        Teacher,
        Group,
        StudentSecret,
        TeacherSecret,
        GroupSecret,
    },
    data() {
        return {
            type: 0,
        }
    },
    mounted() {
        this.type = this.$route.params.type * 1;
    }
}
</script>

<style scoped lang="scss">
.agreement-wrap {
    padding: 12px;
    box-sizing: border-box;
}
</style>